import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Le risorse NON sono importate qui: un import statico le faceva finire nel
// bundle app condiviso da tutte le pagine (251KB minificati, il 62% di
// app.js), cioe' ogni visitatore scaricava anche la lingua che non legge.
// Ora arrivano da due parti, e nessuna delle due pesa su tutte le pagine:
//   - le stringhe comuni a ogni pagina (`common`, `404`) stanno nel bundle
//     core per locale, src/locales/{it,en}/index.js: nel browser le carica
//     l'import() dinamico qui sotto, awaitato in onClientEntry
//     (gatsby-browser.js), che Gatsby completa prima di idratare. Senza
//     l'await il primo render mostrerebbe le chiavi grezze al posto del testo.
//     In SSR le registra staticamente gatsby-ssr.js, dove il peso non conta.
//   - le stringhe di una singola pagina viaggiano nel suo pageContext, cioe'
//     in page-data.json, e le registra wrapPageElement prima del render (vedi
//     onCreatePage in gatsby-node.js e src/config/i18n-namespaces.js).
// Lo split per lingua serve perche' il cambio lingua fa un full page load
// (Header.jsx), quindi una sessione SPA vive in una lingua sola; quello per
// pagina perche' dentro la stessa lingua le pagine usano due namespace su 22.
const BUNDLES = {
  it: () => import("./locales/it/index.js"),
  en: () => import("./locales/en/index.js"),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {},
    fallbackLng: "en",
    supportedLngs: ["it", "en"],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["path", "htmlTag", "localStorage", "navigator"],
      lookupFromPathIndex: 0,
      caches: ["localStorage"],
    },
  });

// Registra un bundle di risorse gia' in memoria (usata dall'SSR).
export function registerLanguage(lng, resources) {
  Object.entries(resources).forEach(([ns, value]) => {
    if (!i18n.hasResourceBundle(lng, ns)) {
      i18n.addResourceBundle(lng, ns, value);
    }
  });
}

// Scarica e registra le risorse di una lingua (usata dal browser).
export async function loadLanguage(lng) {
  const load = BUNDLES[lng] || BUNDLES.en;
  const mod = await load();
  registerLanguage(lng, mod.default);
}

export default i18n;
